<template>
  <car-finance-list :vendor="'1'"></car-finance-list>
</template>

<script>
import CarFinanceList from '@/components/CarFinanceList';
export default {
  name: 'ChaileaseList',
  components: { CarFinanceList }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/ChaileaseList.vue